// vue components 3rd party
import { Affix } from 'vue-affix';
import VueScrollactive from 'vue-scrollactive';
import VueMeta from 'vue-meta';
import { LazyYoutube } from "vue-lazytube";

// vue components
import RequirementClasses from './vue/components/_requirement-classes.vue';
import RequirementRating from './vue/components/_requirement-rating.vue';
import TravelRating from './vue/components/_travel-rating.vue';
import TravelReviewItem from './vue/components/_travel-review-item.vue';
import ShipDetail from './vue/components/_ship-detail.vue';
import ShipListItem from './vue/components/_ship-list-item.vue';
import SectionsNavbar from './vue/components/_sections-navbar.vue';
import TravelGallery from './vue/components/_travel-gallery.vue';
import PanoViewer from './vue/components/_pano-viewer.vue';
import Krpano from "vue-krpano";

Vue.use(VueMeta);
Vue.use(VueScrollactive);
Vue.component('affix', Affix);
Vue.component('requirement-classes', RequirementClasses);
Vue.component('requirement-rating', RequirementRating);
Vue.component('travel-rating', TravelRating);
Vue.component('sections-navbar', SectionsNavbar);
Vue.component('travel-gallery', TravelGallery);
Vue.component('travel-review-item', TravelReviewItem);
Vue.component('ship-detail', ShipDetail);
Vue.component('ship-list-item', ShipListItem);
Vue.component('pano-viewer', PanoViewer);
Vue.component('lazy-youtube', LazyYoutube);
Vue.component('krpano', Krpano);